import React, { memo, forwardRef } from "react";
const SvgContains = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M9 22a1 1 0 100 2h7a8 8 0 100-16H9a1 1 0 100 2h7a6.002 6.002 0 015.917 5H10a1 1 0 100 2h11.917A6.002 6.002 0 0116 22H9z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgContains.displayName = "SvgContains";
const MemoForwardRef = memo(SvgContains);
export default MemoForwardRef;
